import React from 'react';
import PropTypes from 'prop-types';
import FloatInLimits from './FloatInLimits';
import IntegerInLimits from './IntegerInLimits';

const wrapperPropTypes = {
  onChange: PropTypes.func,
};

export function withIntegerInLimits(Component, min, max) {
  const wrapper = (props) => (
    <IntegerInLimits min={min} max={max} onChange={props.onChange}>
      <Component {...props} />
    </IntegerInLimits>
  );
  wrapper.propTypes = wrapperPropTypes;

  return wrapper;
}

export function withFloatInLimits(Component, min, max, precision) {
  const wrapper = (props) => (
    <FloatInLimits precision={precision} min={min} max={max} onChange={props.onChange}>
      <Component {...props} />
    </FloatInLimits>
  );
  wrapper.propTypes = wrapperPropTypes;

  return wrapper;
}
